import { useState } from "react";

import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandMore from "@mui/icons-material/ExpandMore";
import Radio from "@mui/material/Radio";
import { useTranslation } from "i18n";
import { capitalizeFirstLetter } from "utils/Utils";

import "./style.css";

const FilterCollapse = ({
  collapseChildren,
  headerTitle,
  onChange,
  hasImg,
  airlineCarrier,
  includedCarrierCodes,
}) => {
  // Collapsed by default; only groups with an active selection on first
  // render (e.g. filters coming from the URL) start expanded.
  const [open, setOpen] = useState(() =>
    collapseChildren?.some((item) =>
      hasImg ? includedCarrierCodes?.includes(item) : item?.checked
    )
  );
  const { t } = useTranslation();

  const selectedCount = collapseChildren.filter((item) =>
    hasImg ? includedCarrierCodes?.includes(item) : item?.checked
  ).length;

  return (
    <List
      className="filter-collapse"
      sx={{
        width: "100%",
        maxWidth: 360,
        bgcolor: "transparent",
        my: 1,
      }}
      component="nav"
      aria-labelledby="nested-list-subheader"
    >
      <ListItemButton
        className={`filter-collapse__header${open ? " is-open" : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <ListItemText
          className="primary-text filter-collapse__title"
          primary={headerTitle}
        />
        {selectedCount > 0 && (
          <span className="filter-collapse__count">{selectedCount}</span>
        )}
        <ExpandMore className="filter-collapse__chevron" />
      </ListItemButton>
      <Collapse
        className="filter-collapse__body"
        in={open}
        timeout={240}
        unmountOnExit
      >
        <List component="div" disablePadding className="filter-collapse__options">
          {collapseChildren.map((item, index) => {
            const checked = hasImg
              ? includedCarrierCodes.includes(item)
              : item.checked;

            return (
              <div
                className={`item-flex mb-8 filter-collapse__option${
                  checked ? " is-checked" : ""
                }`}
                key={index}
                role="button"
                tabIndex={0}
                onClick={() => onChange?.(item)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onChange?.(item);
                  }
                }}
              >
                <Radio checked={checked} tabIndex={-1} disableRipple />
                <div className="pass-users flex-row filter-collapse__option-content">
                  {hasImg && item && (
                    <img
                      className="results-card-logo logos-collapse filter-collapse__logo"
                      src={airlineCarrier[item]?.carrierLogo[0]?.squareImage}
                      alt=""
                    />
                  )}

                  <p className="filter-collapse__option-label">
                    {hasImg && item
                      ? capitalizeFirstLetter(airlineCarrier[item]?.carrierName)
                      : item.labelKey
                      ? t(item.labelKey)
                      : item.value}
                  </p>
                </div>
              </div>
            );
          })}
        </List>
      </Collapse>
    </List>
  );
};

export default FilterCollapse;
